import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative min-h-screen-dynamic flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20mountain%20landscape%20at%20golden%20hour%20with%20layers%20of%20misty%20hills%20fading%20into%20distance%2C%20warm%20amber%20and%20soft%20sage%20green%20tones%2C%20traditional%20temple%20roof%20silhouette%20among%20cedar%20trees%2C%20gentle%20atmospheric%20haze%20creating%20depth%20and%20tranquility%2C%20minimalist%20nature%20photography%20with%20meditative%20mood%2C%20serene%20wabi%20sabi%20aesthetic%20with%20subtle%20warm%20earth%20colors%20and%20organic%20composition&width=1600&height=800&seq=cta-japanese-2026&orientation=landscape"
          alt="日本山巒暮色與寺院遠景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-900/60"></div>
      </div>

      <div className="relative z-10 section-container text-center w-full py-16 md:py-0">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-white mb-6 leading-tight">
            走進下一段尚未抵達的故事
          </h2>
          <p className="text-sm md:text-base text-white/75 leading-relaxed mb-10 max-w-2xl mx-auto">
            從心動相遇、日常陪伴到遺憾、重逢與成長，透過未境原創目前公開的正式作品，找到下一段值得走進的情感故事。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
            <Link
              to="/about"
              className="px-6 py-3 text-sm font-label bg-white text-primary-800 rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
            >
              認識未境原創
            </Link>
            <Link
              to="/stores"
              className="px-6 py-3 text-sm font-label bg-white/15 text-white border border-white/30 rounded-full hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              查看合作購書通路
            </Link>
            <a
              href="https://catalog.sonbook.net/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-6 py-3 text-sm font-label bg-white/15 text-white border border-white/30 rounded-full hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              查詢完整書目
            </a>
            <a
              href="https://sonbook.net"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-6 py-3 text-sm font-label bg-white/15 text-white border border-white/30 rounded-full hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              前往崧博出版
            </a>
          </div>

          <div className="border-t border-white/15 pt-10 max-w-2xl mx-auto">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-3">
              品牌經銷與合作洽詢
            </h3>
            <p className="text-sm text-white/65 leading-relaxed mb-6 max-w-xl mx-auto">
              如有未境原創品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過官方聯絡方式提出詢問。
            </p>
            <p className="text-xs text-white/50 mb-8">
              品牌經銷與合作方案詳情請直接聯繫洽詢。
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <p className="text-xs md:text-sm text-white/55 leading-relaxed">
              未境原創 VIJING 以愛情小說為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。完整書名、作者與出版資訊，請前往崧博書籍資料庫查詢。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}